<template>
  <div>
    <div class="d-flex align-items-end justify-content-between gap-3">
      <b-skeleton-wrapper
        :loading="loadingFiles"
        class="w-50"
      >
        <template #loading>
          <b-skeleton
            width="100%"
            height="1.5rem"
          ></b-skeleton>
        </template>
        <h4 class="font-weight-bold text-primary-darker mb-0 text-nowrap">{{ title }}</h4>
      </b-skeleton-wrapper>
      <div
        v-if="!loadingFiles && description"
        class="text-wrap text-muted font-size-70 mb-0"
        >{{ description }}</div
      >
    </div>
    <hr class="bg-gray-400" />

    <b-alert
      :show="!!errorHandlingMessage"
      variant="danger"
      dismissible
      >{{ errorHandlingMessage }}</b-alert
    >
    <div
      v-if="loadingFiles"
      class="mt-4"
    >
      <b-skeleton
        width="40%"
        class="mb-3"
      ></b-skeleton>
      <b-skeleton
        width="100%"
        height="2rem"
        class="mb-2"
      ></b-skeleton>
      <b-skeleton
        width="60%"
        height="2rem"
      ></b-skeleton>
    </div>
    <div
      v-else-if="!loadingFiles && fileManagerData && fileManagerData.children && fileManagerData.children.length"
      key="hasFiles"
    >
      <template v-for="(child, idx) in fileManagerData.children">
        <!-- <hr
          :key="child.key + '-separator'"
          v-if="idx !== 0 && fileManagerData.children.length > 1"
        /> -->
        <FlowObjectFileGroup
          :key="child.key"
          :group="child"
          :files-meta="fileManagerData.files_meta"
          :class="{ 'mb-4': idx !== fileManagerData.children.length - 1 }"
        />
      </template>
    </div>
    <!-- Empty State -->
    <div
      v-else-if="!loadingFiles"
      key="noFiles"
      class="text-center"
    >
      <p class="text-muted mb-0">No files to display</p>
    </div>
  </div>
</template>

<script>
  import { errorHandling } from '@/js/custom-vue-mixins';
  import { getFlowObjectApi } from '@/js/api-service';
  import FlowObjectFileGroup from './FlowObjectFileGroup.vue';

  export default {
    name: 'FlowObjectFileList',
    mixins: [errorHandling],
    components: {
      FlowObjectFileGroup,
    },
    props: {
      flowObjectClass: { required: true },
      flowSubtype: { default: null },
      flowObjectId: { required: true },
      fileManagerKey: { required: false },
    },
    data() {
      return {
        fileManagerData: null,
        loadingFiles: false,
        errorHandlingMessage: null,
      };
    },
    computed: {
      title() {
        return this.fileManagerData ? this.fileManagerData.label : 'Files';
      },
      description() {
        return this.fileManagerData ? this.fileManagerData.description : '';
      },
      flowObjectApi() {
        return getFlowObjectApi(this.flowObjectClass, this.flowSubtype);
      },
    },
    mounted() {
      this.getFiles();
    },
    methods: {
      async getFiles() {
        this.loadingFiles = true;
        try {
          const response = await this.flowObjectApi.get_filemanager_data(this.flowObjectId, { params: { key: this.fileManagerKey } });
          this.fileManagerData = response.data;
        } catch (error) {
          this.apiErrorHandler(error, 'Failed to load files', true);
        } finally {
          this.loadingFiles = false;
        }
      },
      async refresh() {
        // Public method to refresh file list
        return await this.getFiles();
      },
    },
  };
</script>
